import React from 'react';
import ICalInput from './input';

const config = {
  // List Table
  list: {
    // Table Columns
    columns: [
      {
        title: 'Roster',
        dataIndex: 'roster__name',
        width: '130px',
        sorter: true,
        defaultSortOrder: 'ascend',
        render: (text, record) => record.roster.name
      },
      {
        title: 'Link',
        dataIndex: 'url',
        sorter: false
      }
    ],
    // Deleting
    confirmMessage: () => (
      <div>
        <p>
          Are you sure you wish to delete this ical link?
        </p>
        <p>
          This will stop calendar syncing on any connected devices.
        </p>
      </div>
    ),
    // Filtering
    sorter: {
      field: 'roster__name',
      order: 'ascend'
    },
    filters: {},
    customFilters: {},
    // General
    title: 'ICal URLs',
    commands: {
      showDelete: false,
      showAdd: false
    }
  },
  // Detail Screen
  detail: {
    // General
    emptyMessage: 'Please select a Record',
    title: 'ICal',
    component: props => (
      <ICalInput
        {...props}
        title="ICal URL"
        inputFormItemLayout={{
          inputLayout: {
            labelCol: {
              xs: { span: 24 },
              sm: { span: 8 }
            },
            wrapperCol: {
              xs: { span: 24 },
              sm: { span: 16 }
            }
          }
        }}
      />
    )
  }
};

export default config;
